// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import { Box, Breadcrumbs, Grid, Link } from '@mui/material';
import { alertsRoutes } from 'pages/Alerts/Alerts.routes';
import { assetsOverviewRoutes, assetsRoutes } from 'pages/Assets/Assets.routes';
import { blueprintsOverviewRoutes, blueprintsRoutes, newBlueprintRoute } from 'pages/Blueprints/Blueprints.routes';
import { managementRoutes } from 'pages/Management/Management.routes';
import { newProjectRoute, projectsRoutes } from 'pages/Projects/Projects.routes';
import { Link as RouterLink } from 'react-router-dom';
import useBreadcrumbs, { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';
import { Icons } from 'greener-ui-library';

export function Breadcrumb() {
  const breadcrumbs = useBreadcrumbs([
    ...alertsRoutes,
    ...projectsRoutes,
    ...managementRoutes,
    ...(assetsRoutes as BreadcrumbsRoute[]),
    ...(assetsOverviewRoutes as BreadcrumbsRoute[]),
    ...(blueprintsOverviewRoutes as BreadcrumbsRoute[]),
    ...(blueprintsRoutes as BreadcrumbsRoute[]),
    ...([newProjectRoute] as unknown as BreadcrumbsRoute[]),
    ...([newBlueprintRoute] as unknown as BreadcrumbsRoute[]),
  ]);

  return (
    <Box sx={{ overFlow: 'hidden', pb: 2 }}>
      <Grid container>
        <Grid item>
          <Breadcrumbs
            separator={<Icons.NavigateNext fontSize="small" sx={{ color: 'grey.500' }} />}
            aria-label="breadcrumb"
          >
            {breadcrumbs.map(
              ({ match, breadcrumb }, i) =>
                breadcrumb !== '' && (
                  <Link
                    key={match.pathname}
                    variant="body1"
                    to={match.pathname}
                    component={RouterLink}
                    sx={{
                      textDecoration: 'none',
                      color: i === breadcrumbs.length - 1 ? 'grey.700' : 'grey.500',
                      '&:hover': {
                        color: i === breadcrumbs.length - 1 ? 'grey.900' : 'grey.700',
                      },
                    }}
                  >
                    {breadcrumb}
                  </Link>
                )
            )}
          </Breadcrumbs>
        </Grid>
      </Grid>
    </Box>
  );
}
